export class AuthModel {
  public username?: string; //thông tin có thể lấy từ token
  public accessToken?: string;
  public refreshToken?: string;
  public token?: string;
  public expirationAt?: number; //đơn vị là ms
  public expireTime?: number; //đơn vị là ms
  // private issuedAt: number;
  constructor(auth?: AuthModel) {
    if (auth) {
      Object.assign(this, auth);
      this.expirationAt = auth.expireTime * 1000 + new Date().getTime();
      this.token = auth.accessToken;
    }
  }
}
export const PERMISSIONS = {
  user: 'ID_USER',
  admin: 'ADMIN',
  accountant: 'ACCOUNTANT',
  shop: 'NUTRI_SHOP',
  store: 'STORE',
  sale_1:"SALE_1",
  sale_2:"SALE_2",
  nutrishop_1:"NUTRISHOP_1",
} as const;

export const NO_PERMISSIONS = 'un_authorize' as const

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);

export type PermissionKeys = keyof typeof PERMISSIONS;
export type Permissions = (typeof PERMISSIONS)[PermissionKeys] | typeof NO_PERMISSIONS;

export interface UserInfo {
  id: number;
  userId: number | null;
  fullName: string;
  username: string;
  shopName: string | null;
  address: string | null;
  phoneNumber: string | null;
  role: Permissions;
  token: any;
  avatar: any;
  region: {
    leadRegion: string;
    selfRegion: string;
    leadProvince: string;
    selfProvince: string;
  };
  cccdFront: string;
  cccdBack: string;
  taxCode: string;
}